import * as React from "react";
import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import Typography from "@mui/material/Typography";
import DialplanNode, { useDialplanNodeContext } from "./DialplanNode";
import Accordion from "../Accordion";
import { useDialplanEditorContext } from "./DialplanEditorContext";
import TtsAnnounce from "./TtsAnnounce";

const CALL_STATUS_OPTIONS = [
  { value: "BUSY", label: "🔶 Occupato/Rifiutato", description: "Quando la linea è occupata o la chiamata viene rifiutata" },
  { value: "UNAVAILABLE", label: "📵 Non raggiungibile", description: "Quando il numero è spento o non raggiungibile" },
  { value: "NO_ANSWER", label: "🔕 Non risponde", description: "Quando il telefono squilla ma non viene risposto" }
];

function CallStatusRouting() {
  const { isEditMode } = useDialplanEditorContext();
  const { node, setNodeChild } = useDialplanNodeContext();
  const [openAccordion, setOpenAccordion] = React.useState(false);
  const { selectedStatus } = node;

  const selectedOption = CALL_STATUS_OPTIONS.find(option => option.value === selectedStatus);

  return (
    <Grid container direction={"column"}>
      <Grid item xs={12}>
        <div style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}>
          <Typography variant="h6" align="left">
            📞 Risposta in base allo stato della chiamata
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }} justifyContent="flex-start">
        <Typography variant="body" display={"inline"}>
          Definisci azioni diverse in base allo stato della chiamata.
        </Typography>
      </Grid>
      
      {isEditMode && (
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Seleziona lo stato specifico da gestire:
            </Typography>
            <FormControl fullWidth>
              <Select
                value={selectedStatus || "BUSY"}
                onChange={(e) => setNodeChild("selectedStatus")(e.target.value)}
                size="small"
              >
                {CALL_STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    <div>
                      <Typography variant="body1" component="div">
                        {option.label}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" component="div">
                        {option.description}
                      </Typography>
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      )}

      {!isEditMode && selectedOption && (
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              <strong>Stato selezionato:</strong> {selectedOption.label}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {selectedOption.description}
            </Typography>
          </Grid>
        </Grid>
      )}

      <Grid item container sx={{ mt: 4 }}>
        <Accordion 
          title={`🟩`}
          description={`Risposta quando ${selectedOption.description?.toLowerCase() || ''}`}
          expanded={openAccordion === "selected"}
          onChange={() => setOpenAccordion(openAccordion === "selected" ? false : "selected")}
        >
          <DialplanNode prop="selectedCase"/>
        </Accordion>
        
        <Accordion 
          title={"🟦"}
          description={"Risposta per tutti gli altri casi"}
          expanded={openAccordion === "other"}
          onChange={() => setOpenAccordion(openAccordion === "other" ? false : "other")}
        >
          <DialplanNode prop="otherCases"/>
        </Accordion>
      </Grid>
    </Grid>
  );
}

CallStatusRouting.description = "Permette di definire azioni diverse in base allo stato di fallimento della chiamata (occupato, non disponibile, non risponde)";
CallStatusRouting.title = "Risposta in base allo stato della chiamata";
CallStatusRouting.default = {
  type: "CALL_STATUS_ROUTING",
  selectedStatus: "BUSY",
  selectedCase: { 
    ...TtsAnnounce.default, 
    text: "La linea è attualmente occupata, riprova più tardi." 
  },
  otherCases: { 
    ...TtsAnnounce.default, 
    text: "Il numero chiamato non è al momento raggiungibile." 
  },
};
CallStatusRouting.isAdvanced = true;

export default CallStatusRouting; 